import React from 'react';

import { Link, Stack, Typography, Breadcrumbs } from '@mui/material';

import { useRouter } from 'src/routes/hooks';

export type BreadcrumbPage = {
  label: string;
  href?: string;
  icon?: React.ReactNode;
};

type BreadcrumbsNavProps = {
  pages: BreadcrumbPage[];
};

export const BreadcrumbsNav = ({ pages }: BreadcrumbsNavProps) => {
  const router = useRouter();
  return (
    <Breadcrumbs aria-label="breadcrumb" separator="/">
      {pages.map((page, index) => {
        const isLast = index === pages.length - 1;
        const content = (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            {page.icon}
            <span>{page.label}</span>
          </Stack>
        );

        if (!page.href || isLast) {
          return (
            <Typography
              key={index}
              component="div"
              color="text.primary"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              {content}
            </Typography>
          );
        }

        return (
          <Link
            key={`${index}-${page.label}`}
            onClick={() => router.push(page.href!)}
            underline="hover"
            color="text.primary"
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            {content}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};
